export const MOBILE_MAIN_HEADER_V3_HEIGHT = 50;